//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
    selections: {
      type: Array,
      default: [
        {label: '全部',value: 0},
        {label: 'DMP服务器',value: 0},
        {label: '一体机电脑',value: 0},
        {label: '迷你主机',value: 0},
          ]
    }
  },
    data () {
        return {
        current:0,
        menuName:[
            {name:"菜单1",show:false},
            {name:"菜单2",show:false},
            {name:"菜单3",show:false},
            ],
        Submenu:[
          {name:"工业应用",id:"1"},
          {name:"采集设备",id:"2"},
          {name:"无线扫描枪",id:"3"}],
        secondMenu:[
            {name:"全部"},
            {name:"生产管理"},
            {name:"采购供应"},
            {name:"仓储物流"},
            {name:"数据控制"},
            {name:"研发设计"},
            {name:"设备连接"},
        ],
        tabMenu: [
        {name: '全部',value: 0},
        {name: 'DMP服务器',value: 1},
        {name: '一体机电脑',value: 2},
        {name: '迷你主机',value: 3},
          ],
        num:'',
        isShow:0,
        isflag:0,
        isDrop: false,
        nowIndex: 0,
        secondNum:-1,
        secondNum1:-1,
        val:'',
        selectNum:'',
        selectedA: '',
        selectedB: '',
        selectedC: '',
        }
    },
    watch:{

    },
    methods: {
    gotoGood(index){
    this.num=index;
    this.isShow = index;
    },
    showSub(index){
        this.secondNum1=index-1;
        this.selectNum = index;
        if(this.isflag==index){
            this.isflag=0;
        }else{
            this.isflag=index;
        }
    },
    shownum(index){
        this.secondNum=index;
    },
    toggleDrop (index) {
      this.isDrop = !this.isDrop
    },
    chooseSelection (index) {
      this.nowIndex = index
      this.isDrop = false
      this.$emit('on-change', this.selections[this.nowIndex])
    },
    changeTXT(e,index){

         console.log(this.Submenu[index])
         this.val = e.target.innerHTML
         this.Submenu[index].name=this.val
         console.log(this.Submenu[index])
    }
    },


}



// WEBPACK FOOTER //
// ./src/views/goods/search.vue